var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 43035"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.6666 7.66641L13.6666 16.0664M13.6666 16.0664L10.0666 12.4664M13.6666 16.0664L17.2666 12.4664",
    stroke: "#008556",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.86655 19.6665L13.6666 19.6665L18.4666 19.6665",
    stroke: "#008556",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M25.6665 13.6665C25.6665 19.3234 25.6665 22.1518 23.9091 23.9091C22.1518 25.6665 19.3234 25.6665 13.6665 25.6665C8.0097 25.6665 5.18118 25.6665 3.4239 23.9091C1.6665 22.1518 1.6665 19.3234 1.6665 13.6665C1.6665 8.0097 1.66651 5.18118 3.42391 3.4239C5.18119 1.6665 8.00971 1.6665 13.6665 1.6665C19.3234 1.6665 22.1518 1.6665 23.9091 3.4239C25.6665 5.18118 25.6665 8.0097 25.6665 13.6665Z",
    stroke: "#008556",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.6f714b9836bbe321e448f4515188e790.svg";
export { ForwardRef as ReactComponent };